import { useEffect, useState } from "react";
import { Megaphone, X } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { MSG_EVT } from "@/lib/telemetry";
import { Logo } from "@/components/Logo";
import { addNotif } from "@/lib/notifications";

const STARS = [[6, 20, 2], [18, 75, 1], [30, 15, 1], [44, 85, 2], [57, 30, 1], [66, 70, 1], [78, 12, 2], [88, 55, 1], [95, 85, 1], [38, 55, 1], [12, 45, 1], [72, 40, 1]];

export function RemoteMessage() {
  const { t } = useApp();
  const [msg, setMsg] = useState(null);
  useEffect(() => {
    const h = (e) => { setMsg(e.detail); addNotif("admin", e.detail?.text); };
    window.addEventListener(MSG_EVT, h);
    return () => window.removeEventListener(MSG_EVT, h);
  }, []);
  if (!msg) return null;
  const long = (msg.text || "").length > 160;
  return (
    <div className="fixed inset-x-0 top-0 z-[80] flex justify-center px-3 pt-3 pointer-events-none" data-testid="remote-message">
      <div className="pointer-events-auto relative max-w-2xl w-full rounded-2xl overflow-hidden text-white shadow-[0_20px_60px_rgba(0,0,0,.6)] border border-white/15 animate-in slide-in-from-top"
        style={{ background: "radial-gradient(ellipse at 80% 0%, rgba(242,140,40,.35), transparent 55%), radial-gradient(ellipse at 10% 100%, rgba(92,200,232,.25), transparent 50%), #0B1530" }}>
        {STARS.map(([x, y, s], i) => (
          <span key={i} className="absolute rounded-full bg-white pointer-events-none" style={{ left: `${x}%`, top: `${y}%`, width: s, height: s, opacity: .8, animation: `orbit-twinkle ${2 + (i % 4)}s ease-in-out ${i * 0.25}s infinite` }} />
        ))}
        <div className="absolute -right-10 -bottom-14 w-56 h-56 opacity-25 pointer-events-none" style={{ animation: "orbit-spin 40s linear infinite" }}>
          <Logo className="w-56 h-56" />
        </div>
        <div className="relative px-5 py-4 flex items-start gap-3">
          <Megaphone className="w-7 h-7 text-[#F28C28] shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <div className="text-xs font-bold uppercase tracking-[.2em] text-[#F28C28]">{t("remote_msg_from")}</div>
            <div className={`${long ? "text-sm sm:text-base font-medium" : "text-lg sm:text-xl font-bold"} text-white leading-snug break-words whitespace-pre-line max-h-[60vh] overflow-y-auto pr-1`} data-testid="remote-message-text">{msg.text}</div>
          </div>
          <button type="button" onClick={() => setMsg(null)} className="h-10 w-10 rounded-xl bg-white/10 hover:bg-white/20 grid place-items-center shrink-0" aria-label={t("close")} data-testid="remote-message-close"><X className="w-5 h-5" /></button>
        </div>
      </div>
    </div>
  );
}
